import React from "react";
import FieldSection from "./FieldSection";
import Field from "../../atoms/field/Field.jsx";
import Fieldset from "../../atoms/fieldset/FieldSet.jsx";
import RequiredCaption from "./RequiredCaption";
import InputAutocomplete from "./InputAutocomplete";
import Button from "../button/ButtonController.jsx";
import { useIntl, FormattedMessage } from "react-intl";

const DeliveryForm = ({
  accept_conditions,
  className,
  companyEmail,
  changeTypeOfCustomer,
  data,
  errors,
  is_shipping,
  isRegistration,
  onChange,
  onSaveClick,
  onShowBillingAddressClick,
  showBillingAddress,
  slim,
  updateCoordinates,
  updateStreet,
}) => {
  const intl = useIntl();
  const delivery_or_shipping_name = is_shipping
    ? intl.formatMessage({ id: "shippingAddress" })
    : intl.formatMessage({ id: "deliveryAddress" });
  const required_star = data.type === "COM" ? " " : "*";
  return (
    <div className={className} onChange={onChange}>
      {!slim && (
        <FieldSection title={intl.formatMessage({ id: "loginDetails" })}>
          <Field
            type="email"
            name="email"
            data={data}
            errors={errors}
            label="Email*"
            required
          />
          <Field
            type="password"
            name="password"
            data={data}
            errors={errors}
            label={intl.formatMessage({ id: "password" }) + "*"}
            info={
              errors["password"]
                ? intl.formatMessage({ id: "passwordRequirement" })
                : ""
            }
            required
          />
        </FieldSection>
      )}
      <FieldSection title={delivery_or_shipping_name}>
        <>
          <Field
            label={intl.formatMessage({ id: "name" }) + "*"}
            name="delivery_address_name"
            data={data}
            errors={errors}
            required
          />
          <Field
            label={intl.formatMessage({ id: "surname" }) + "*"}
            name="delivery_address_lastname"
            data={data}
            errors={errors}
            required
          />
        </>
        <InputAutocomplete
          data={data}
          errors={errors}
          onSaveClick={onSaveClick}
          updateCoordinates={updateCoordinates}
          updateStreet={updateStreet}
          name="delivery_address_street"
          required
        />
        <Fieldset>
          <Field
            maxLength={5}
            disabled
            readOnly
            label={intl.formatMessage({ id: "postcode" }) + "*"}
            name="delivery_address_postcode_number"
            data={data}
            errors={errors}
            required
          />
          <Field
            label={intl.formatMessage({ id: "city" }) + "*"}
            disabled
            readOnly
            name="delivery_address_postcode_city"
            data={data}
            errors={errors}
            required
          />
        </Fieldset>
        <Field
          label={intl.formatMessage({ id: "phoneNumber" })}
          name="phone_number"
          data={data}
          errors={errors}
          required
        />
        <Field
          label={intl.formatMessage({ id: "deliveryHints" })}
          name="delivery_address_additional_info"
          data={data}
          errors={errors}
        />
        <Field
          label={intl.formatMessage({ id: "timeslot" })}
          name="timeslot"
          data={data}
          errors={errors}
          disabled
          readOnly
          required
        />
        <RequiredCaption />
        {!isRegistration && (
          <p className="paragraph">
            <FormattedMessage
              id="hintChangesDelivery"
              values={{
                delivery_or_shipping_name: delivery_or_shipping_name,
                companyEmail: companyEmail,
              }}
            />
          </p>
        )}
        <Field
          style={{
            backgroundColor: "white",
            paddingTop: "1rem",
            paddingBottom: "1rem",
          }}
          type="radio"
          name="type"
          data={data}
          errors={errors}
          onChange={(e) => {
            changeTypeOfCustomer(e);
          }}
          options={[
            { value: "PRI", text: intl.formatMessage({ id: "private" }) },
            { value: "COM", text: intl.formatMessage({ id: "business" }) },
          ]}
          horizontal
          required
        />
        <Field
          onClick={onShowBillingAddressClick}
          type="checkbox"
          name="different_invoice_address"
          data={data}
          errors={errors}
        >
          <FormattedMessage id="differentBillingAddress" />
        </Field>
        {showBillingAddress && (
          <FieldSection>
            <Field
              label={intl.formatMessage({ id: "name" }) + required_star}
              name="firstname"
              data={data}
              errors={errors}
              required={data.type === "COM" ? false : true}
            />
            <Field
              label={intl.formatMessage({ id: "surname" }) + required_star}
              name="lastname"
              data={data}
              errors={errors}
              required={data.type === "COM" ? false : true}
            />
            <Field
              label={intl.formatMessage({ id: "companyName" }) + required_star}
              name="company_name"
              data={data}
              errors={errors}
              required={data.type === "COM" ? true : false}
            />
            <Field
              label={
                intl.formatMessage({ id: "contactPerson" }) + required_star
              }
              name="company_contact_person"
              data={data}
              errors={errors}
              required={data.type === "COM" ? true : false}
            />
            <Field
              label={intl.formatMessage({ id: "streetAndHouseNumber" }) + "*"}
              name="billing_address"
              data={data}
              errors={errors}
              required
            />
            <Fieldset>
              <Field
                maxLength={5}
                label={intl.formatMessage({ id: "postcode" }) + "*"}
                name="billing_postcode"
                data={data}
                errors={errors}
                required
              />
              <Field
                label={intl.formatMessage({ id: "city" }) + "*"}
                name="billing_city"
                data={data}
                errors={errors}
                required
              />
            </Fieldset>
            <Field
              label={intl.formatMessage({ id: "countryCode" }) + "*"}
              name="billing_country"
              data={data}
              errors={errors}
              required
            />
            <RequiredCaption />
          </FieldSection>
        )}
        {!slim && <>{accept_conditions}</>}
        <Button onClick={onSaveClick} id="save-button-form">
          {slim
            ? intl.formatMessage({ id: "saveChanges" })
            : intl.formatMessage({ id: "saveAndContinue" })}
        </Button>
      </FieldSection>
    </div>
  );
};

export default DeliveryForm;
